import styled from 'styled-jss'

export const SpinnerWrapper = styled('div')({
  maxWidth: 100,
  minHeight: '100vh',
  display: 'flex',
  margin: '0 auto',
  '&.wrapper-spinner': {
    maxWidth: '100%',
    position: 'absolute',
    minHeight: '100vh',
    display: 'flex',
    margin: '0 auto',
    width: '100vw',
    zIndex: '100',
    top: 0,
    left:0,
    background: '#fff',
  },
  '& > svg': {
    height: '100%',
    width: '100%',
    transform: (props) => (props.isLarge ? 'scale(1.7)' : 'none'),
  },
})